interface FormConfiguration {
    [key: string]: Array<{
        label: string;
        value: string;
        type?: string;  // 'date' | 'boolean' | 'situatie_militara' | 'rang_militar' | 'regim_matrimonial'
    }>;
}

export const militaryStatuses: { name: string, value: string }[] = [
    { name: 'Activ', value: 'active' },
    { name: 'Recrut', value: 'recruit' },
    { name: 'Rezervist', value: 'retired' },
    { name: 'Fără obligații militare', value: 'none' }
]

export const militaryRanks: { name: string, value: string }[] = [
    { name: 'Ofițer', value: '3' },
    { name: 'Maistru militar', value: '4' },
    { name: 'Subofițer', value: '5' },
    { name: 'Gradat-soldat', value: '6' }
]

export const matrimonialRegimes: { name: string, value: string }[] = [
    { name: 'Regimul matrimonial legal', value: 'legal' },
    { name: 'Regimul separației de bunuri', value: 'separationOfGoods' },
    { name: 'Regimul comunității convenționale', value: 'conventionalCommunity' }
]

export const formConfigurations: FormConfiguration = {
    'suport_web': [],
    'email_registratura': [],
    'alte_sugestii_probleme': [],
    'diverse_probleme': [],
    'suport_it': [],
    'expiryChangesDamageLostTheftTransformation': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'firstIdentityCardAfterAge18': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'firstIdentityCardAfterAge14': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'changedResidence': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'changeOfResidenceFromForeignCountryToRomania': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Prenume anterior', value: 'prenume_anterior' },
        { label: 'Nume soț', value: 'nume_sot' },
        { label: 'Prenume soț', value: 'prenume_sot' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'acquiredRomanianCitizenship': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Prenume anterior', value: 'prenume_anterior' },
        { label: 'Nume soț', value: 'nume_sot' },
        { label: 'Prenume soț', value: 'prenume_sot' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'temporaryIdentityCard': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'temporaryIdentityCardForRomaniansWithForeignDomicileAndRomanianResidence': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Nume găzduitor', value: 'nume_gazduitor' },
        { label: 'Prenume găzduitor', value: 'prenume_gazduitor' },
        { label: 'Serie conform CI/BI Găzduitor', value: 'ci_serie_gazduitor' },
        { label: 'Număr conform CI/BI Găzduitor', value: 'ci_numar_gazduitor' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'establishedResidence': [
        { label: 'Nume anterior', value: 'nume_anterior' },
        { label: 'Stare civilă', value: 'stare_civila' },
        { label: 'Situație militară', value: 'situatie_militara', type: 'situatie_militara' },
        { label: 'Rang militar', value: 'rang_militar', type: 'rang_militar' },
        { label: 'Ultima școală', value: 'ultima_scoala' },
        { label: 'Ocupația actuală', value: 'ocupatia_actuala' },
        { label: 'Serie conform CI/BI Reprezentant', value: 'ci_serie_reprezentant' },
        { label: 'Număr conform CI/BI Reprezentant', value: 'ci_numar_reprezentant' },
        { label: 'Motivație', value: 'observatii' },
        { label: 'Metodă plată', value: 'payment_method' },
    ],
    'programare_casatorie': [
        { label: 'Regim matrimonial', value: 'regim_matrimonial', type: 'regim_matrimonial' },
        { label: 'Anexa 25', value: 'anexa_25', type: 'boolean' },
        { label: 'Dată(anexa 25)', value: 'data_anexa_25', type: 'date' },
        { label: 'Motive(anexa 25)', value: 'motive_anexa_25' },
        { label: 'Documente(anexa 25)', value: 'documente_anexa_25' },
    ],
    'birth': [
        { label: 'Program restricționat cetățenie', value: 'required_moldoveni', type: 'boolean' },
    ],
    'marriage': [
        { label: 'Program restricționat cetățenie', value: 'required_moldoveni', type: 'boolean' },
    ],
    'death': [
        { label: 'Program restricționat cetățenie', value: 'required_moldoveni', type: 'boolean' },
    ],
};
